import type { Locale } from "@/lib/i18n/locale";

/**
 * A blog path in a given language: `/blog/x` in Thai, `/en/blog/x` in English.
 *
 * The blog is the one part of the site whose language lives in its address
 * (see proxy.ts), so every link it renders has to carry the reader's language
 * with it — a card on /en/blog that pointed at /blog/x would drop them back
 * into Thai. Paths are built language-neutral (`/blog/...`) and passed through
 * here at the point they become an href.
 */
export function blogHref(locale: Locale, path: string) {
  return locale === "en" ? `/en${path}` : path;
}

/**
 * The same blog page in another language, or null when `pathname` is not on
 * the blog. Accepts the `/th/...` spelling too, in case the router hands back
 * the rewritten path rather than the address.
 */
export function blogPathIn(pathname: string, locale: Locale): string | null {
  const base = pathname.replace(/^\/(?:th|en)(?=\/)/, "");
  if (!/^\/blog(?:\/|$)/.test(base)) return null;
  return blogHref(locale, base);
}
